import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'; // For API Log
import VerifiedUserOutlined from '@mui/icons-material/VerifiedUserOutlined'; //For audit log
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined'; //For Configuration
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined'; // Organiztion
import MailLockOutlinedIcon from '@mui/icons-material/MailLockOutlined'; //For Out Going Mail
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined'; //Terms & COnditions

import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined'; //For Masters
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'; //For General Masters
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'; //For Location Masters

import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined'; //User and Privileges
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined'; //User Role
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined'; //For User
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined'; //For Password Policy

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'; //Dashboard Menu
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined'; //FOr Enquiry
import MonitorOutlinedIcon from '@mui/icons-material/MonitorOutlined'; //FOr Demo
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined'; //For Lead
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined'; //FOr Subscription Plans
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined'; //For Subscriptions
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined'; //For Invoice
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'; //For CLient
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined'; // For COntact
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'; //For Product

export default {
    ReceiptLongOutlinedIcon : ReceiptLongOutlinedIcon,
    VerifiedUserOutlined : VerifiedUserOutlined,
    SettingsSuggestOutlinedIcon : SettingsSuggestOutlinedIcon,
    CorporateFareOutlinedIcon: CorporateFareOutlinedIcon,
    MailLockOutlinedIcon : MailLockOutlinedIcon,
    GavelOutlinedIcon : GavelOutlinedIcon,
    SettingsOutlinedIcon : SettingsOutlinedIcon,
    PlaceOutlinedIcon : PlaceOutlinedIcon,
    SettingsApplicationsOutlinedIcon : SettingsApplicationsOutlinedIcon,
    FolderSharedOutlinedIcon : FolderSharedOutlinedIcon,
    GroupOutlinedIcon : GroupOutlinedIcon,
    SupervisedUserCircleOutlinedIcon : SupervisedUserCircleOutlinedIcon,
    Person2OutlinedIcon : Person2OutlinedIcon,
    PasswordOutlinedIcon : PasswordOutlinedIcon,
    HomeOutlinedIcon: HomeOutlinedIcon,
    ContactPhoneOutlinedIcon : ContactPhoneOutlinedIcon,
    MonitorOutlinedIcon : MonitorOutlinedIcon,
    CoPresentOutlinedIcon : CoPresentOutlinedIcon,
    LocalOfferOutlinedIcon : LocalOfferOutlinedIcon,
    SubscriptionsOutlinedIcon : SubscriptionsOutlinedIcon,
    ReceiptOutlinedIcon : ReceiptOutlinedIcon,
    BusinessOutlinedIcon : BusinessOutlinedIcon,
    ContactsOutlinedIcon : ContactsOutlinedIcon,
    Inventory2OutlinedIcon : Inventory2OutlinedIcon,
};
